import { State } from "../../client";

interface Props {
  state: State<string>;
  options: string[];
}

export function RadioInput({ state: [selected, setSelected], options }: Props) {
  return (
    <div className="radio-group">
      {options.map((option, optIndex) => (
        <div key={`${optIndex}`} className="radio-item">
          <label>
            <input
              type="radio"
              value={option}
              checked={selected === option}
              onChange={(e) => setSelected(e.target.value)}
            />
            {option}
          </label>
        </div>
      ))}
    </div>
  );
}
